"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Input = _interopRequireDefault(require("../../Input"));
const EditTableCell = _ref => {
  let {
    column,
    initialValue = '',
    inputProps,
    row,
    table,
    onInputChange
  } = _ref;
  const [restInputProps, setRestInputProps] = (0, _react.useState)(inputProps);
  const [value, setValue] = (0, _react.useState)(initialValue);
  (0, _react.useEffect)(() => {
    setRestInputProps(inputProps);
  }, [inputProps]);
  (0, _react.useEffect)(() => {
    setValue(initialValue);
  }, [initialValue]);
  const onBlur = () => {
    var _a;
    (_a = table.options.meta) === null || _a === void 0 ? void 0 : _a.updateData(row.index, column.id, value);
  };
  const onClear = () => {
    setValue('');
    if (typeof column.columnDef.meta.inputProps === 'function') {
      setRestInputProps(column.columnDef.meta.inputProps(row.original, column, ''));
    }
    if (onInputChange) {
      onInputChange('', row.index, column.id);
    }
  };
  const handleChange = e => {
    e.preventDefault();
    setValue(e.currentTarget.value);
    setRestInputProps(column.columnDef.meta.inputProps(row.original, column.columnDef, e.currentTarget.value));
    if (onInputChange) {
      onInputChange(e, row.index, column.id);
    }
  };
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsx)(_Input["default"], (0, _extends2["default"])({
      id: column.id,
      value: value,
      onChange: handleChange,
      onBlur: onBlur,
      onClear: onClear
    }, restInputProps))
  });
};
var _default = exports["default"] = EditTableCell;